import type { HalebopConfirmOrderRequest } from '~/models/checkout/ConfirmOrderRequest.api.model';
import type { CreditCheckResponse } from '~/models/checkout/CreditCheck.api.model';
import FetchFactory from '../factory';
import type { ShippingMethod } from './ShippingMethod.module';
import type { CheckoutLogRequest } from '~/models/checkout/CheckoutLogRequest';

const CONTROLLER_PATH_NOP = '/api-frontend/Checkout/';
const CONTROLLER_PATH_ELECTRA = '/api-electra/Checkout/';
const CREDITCHECK_CONTROLLER_PATH_ELECTRA = '/api-electra/CreditCheck/';

export interface ConfirmOrderResponse {
  Id: number;
  OrderGuid: string;
  RedirectToMethod: string;
}

class CheckoutModule extends FetchFactory<any> {
  async setDeliveryMethod(shippingMethod: ShippingMethod) {
    const param = `${shippingMethod.Name}___${shippingMethod.ShippingMethodSystemName}`;
    const url = `${CONTROLLER_PATH_NOP}SelectShippingMethod?shippingOption=${param}`;
    return await this.call('POST', url, {});
  }

  async confirmOrder(
    payload: HalebopConfirmOrderRequest,
  ): Promise<ConfirmOrderResponse> {
    const url = `${CONTROLLER_PATH_ELECTRA}ConfirmOrder`;
    return await this.post(url, payload).then((response) => {
      return response;
    });
  }

  async creditCheck(orderGuid?: string): Promise<CreditCheckResponse> {
    return await this.get(
      `${CREDITCHECK_CONTROLLER_PATH_ELECTRA}${orderGuid ? `CreditCheckByOrderGuid?orderGuid=${orderGuid}` : 'CreditCheck'}`,
    );
  }

  async logCheckoutData(log: CheckoutLogRequest): Promise<boolean> {
    const url = `${CONTROLLER_PATH_ELECTRA}LogCheckoutStatus`;
    return await this.post(url, log).then((response) => {
      return response;
    });
  }
}

export default CheckoutModule;
